module.exports = __webpack_public_path__ + "img/menu-beneficiary.3200d347.svg";